var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailHallelujahLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 572,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 572,
    fill: "#a08672"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "250,158 113,-16 271,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#010000",
    fillOpacity: 0.501961,
    points: "242,96 6,158 7,62"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d0000",
    fillOpacity: 0.501961,
    points: "158,20 189,133 109,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "256,-16 254,74 53,-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffe2",
    fillOpacity: 0.501961,
    points: "267,131 167,76 214,150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "104,114 119,114 120,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffffa",
    fillOpacity: 0.501961,
    points: "271,-6 271,158 152,-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#813303",
    fillOpacity: 0.501961,
    points: "135,36 150,158 178,24"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#732d0d",
    fillOpacity: 0.501961,
    points: "74,21 -10,57 -14,-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "191,112 156,158 110,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0e0900",
    fillOpacity: 0.501961,
    points: "146,88 35,158 7,108"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bf7128",
    fillOpacity: 0.501961,
    points: "234,97 184,69 190,128"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "271,130 154,158 236,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d39667",
    fillOpacity: 0.501961,
    points: "149,64 104,7 79,105"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7bda7",
    fillOpacity: 0.501961,
    points: "-6,45 -16,74 98,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c57c51",
    fillOpacity: 0.501961,
    points: "73,116 102,158 138,126"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000003",
    fillOpacity: 0.501961,
    points: "226,107 208,94 225,87"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7b677",
    fillOpacity: 0.501961,
    points: "213,98 170,60 167,90"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#362c16",
    fillOpacity: 0.501961,
    points: "7,72 91,69 79,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "185,67 166,-16 271,8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "135,75 84,106 144,107"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffddaf",
    fillOpacity: 0.501961,
    points: "219,50 271,44 232,122"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e7b391",
    fillOpacity: 0.501961,
    points: "183,41 178,12 77,13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "158,-7 62,1 148,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a6582a",
    fillOpacity: 0.501961,
    points: "144,122 172,88 142,79"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212800",
    fillOpacity: 0.501961,
    points: "50,14 67,35 31,29"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#040000",
    fillOpacity: 0.501961,
    points: "92,108 103,98 110,148"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#400000",
    fillOpacity: 0.501961,
    points: "233,141 261,138 217,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1baa2",
    fillOpacity: 0.501961,
    points: "97,40 26,52 25,33"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d5c8b5",
    fillOpacity: 0.501961,
    points: "132,53 45,52 121,74"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000004",
    fillOpacity: 0.501961,
    points: "185,102 189,135 132,142"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff1e0",
    fillOpacity: 0.501961,
    points: "114,142 104,109 118,122"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffaf8",
    fillOpacity: 0.501961,
    points: "148,142 232,158 235,131"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2825b",
    fillOpacity: 0.501961,
    points: "-16,112 17,99 13,-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e68965",
    fillOpacity: 0.501961,
    points: "24,19 33,-8 103,10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#862b00",
    fillOpacity: 0.501961,
    points: "40,52 66,44 90,51"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0d0000",
    fillOpacity: 0.501961,
    points: "3,-1 2,52 -16,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#480e00",
    fillOpacity: 0.501961,
    points: "81,6 76,30 84,39"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a24e23",
    fillOpacity: 0.501961,
    points: "151,90 138,15 130,73"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#551a0f",
    fillOpacity: 0.501961,
    points: "12,53 24,0 27,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#56291a",
    fillOpacity: 0.501961,
    points: "106,47 112,17 115,53"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d29655",
    fillOpacity: 0.501961,
    points: "213,88 197,138 177,74"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#764513",
    fillOpacity: 0.501961,
    points: "64,0 54,42 66,41"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#af7d3c",
    fillOpacity: 0.501961,
    points: "151,67 81,79 86,99"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#86432c",
    fillOpacity: 0.501961,
    points: "126,11 117,50 129,51"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#501100",
    fillOpacity: 0.501961,
    points: "96,38 93,21 99,8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "199,116 237,108 271,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#efc0b8",
    fillOpacity: 0.501961,
    points: "96,15 83,-6 84,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a97123",
    fillOpacity: 0.501961,
    points: "-5,100 15,119 8,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1aea6",
    fillOpacity: 0.501961,
    points: "67,50 79,7 66,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#431b0d",
    fillOpacity: 0.501961,
    points: "148,32 172,82 147,79"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f29658",
    fillOpacity: 0.501961,
    points: "86,139 86,114 98,125"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e0bfa9",
    fillOpacity: 0.501961,
    points: "170,64 171,90 217,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ddb2a0",
    fillOpacity: 0.501961,
    points: "119,61 109,5 126,-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#664a2a",
    fillOpacity: 0.501961,
    points: "86,88 5,102 81,109"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#211d15",
    fillOpacity: 0.501961,
    points: "22,97 14,145 121,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1aaa8",
    fillOpacity: 0.501961,
    points: "4,14 10,-16 20,5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#be9181",
    fillOpacity: 0.501961,
    points: "49,68 24,67 26,13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2e2c1f",
    fillOpacity: 0.501961,
    points: "89,68 22,94 8,69"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "165,12 231,96 202,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d4c5b4",
    fillOpacity: 0.501961,
    points: "11,66 -16,54 56,53"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffdab6",
    fillOpacity: 0.501961,
    points: "260,114 271,-6 226,100"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ce7149",
    fillOpacity: 0.501961,
    points: "137,129 120,121 131,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b99574",
    fillOpacity: 0.501961,
    points: "220,136 218,107 214,124"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#120600",
    fillOpacity: 0.501961,
    points: "103,139 107,130 120,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdbec5",
    fillOpacity: 0.501961,
    points: "123,107 124,116 116,108"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#11100f",
    fillOpacity: 0.501961,
    points: "180,93 112,158 186,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0a0401",
    fillOpacity: 0.501961,
    points: "123,76 110,117 141,78"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bb7a34",
    fillOpacity: 0.501961,
    points: "205,79 190,78 199,134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#83574d",
    fillOpacity: 0.501961,
    points: "-13,35 44,51 -16,52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#edb19b",
    fillOpacity: 0.501961,
    points: "129,18 128,47 140,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#815a30",
    fillOpacity: 0.501961,
    points: "52,68 43,106 38,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a7676",
    fillOpacity: 0.501961,
    points: "177,10 175,19 172,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0cc99",
    fillOpacity: 0.501961,
    points: "171,47 162,-11 153,8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0d0f19",
    fillOpacity: 0.501961,
    points: "218,106 213,88 225,90"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b3f04",
    fillOpacity: 0.501961,
    points: "97,51 99,42 70,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9c774b",
    fillOpacity: 0.501961,
    points: "122,83 75,68 138,70"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4cb9c",
    fillOpacity: 0.501961,
    points: "81,37 103,46 52,46"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2f1e12",
    fillOpacity: 0.501961,
    points: "148,32 137,38 168,39"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e7d9f2",
    fillOpacity: 0.501961,
    points: "213,102 202,108 218,109"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#030503",
    fillOpacity: 0.501961,
    points: "4,102 20,104 30,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a7510f",
    fillOpacity: 0.501961,
    points: "61,13 66,31 34,10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecc7ca",
    fillOpacity: 0.501961,
    points: "111,5 100,8 100,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "230,79 210,69 211,89"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dbdfd9",
    fillOpacity: 0.501961,
    points: "39,36 44,47 58,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b542b",
    fillOpacity: 0.501961,
    points: "104,128 90,150 78,138"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecb052",
    fillOpacity: 0.501961,
    points: "187,98 190,135 201,86"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "48,-7 116,-8 110,9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "154,-16 120,14 147,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6f3500",
    fillOpacity: 0.501961,
    points: "88,76 100,84 108,74"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffffd",
    fillOpacity: 0.501961,
    points: "194,-16 176,60 248,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bda790",
    fillOpacity: 0.501961,
    points: "40,64 98,54 137,73"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9f5f04",
    fillOpacity: 0.501961,
    points: "11,79 9,102 1,71"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fbdbcc",
    fillOpacity: 0.501961,
    points: "117,138 120,116 105,117"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#331206",
    fillOpacity: 0.501961,
    points: "23,21 26,-7 20,6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#171d1a",
    fillOpacity: 0.501961,
    points: "86,91 52,89 64,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "122,158 213,158 196,134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#743c23",
    fillOpacity: 0.501961,
    points: "89,24 99,39 98,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c8ad83",
    fillOpacity: 0.501961,
    points: "102,88 111,76 121,83"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#060606",
    fillOpacity: 0.501961,
    points: "150,145 112,92 133,80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailHallelujahLow);
export default __webpack_public_path__ + "static/media/thumbnail_hallelujah_low.90220395ef33eccdc1e2fed7fb542cd7.svg";
export { ForwardRef as ReactComponent };